<agr-page-toolbar [pageTitle]="pageTitle$ | async" [hasSecondaryAction]="false">
  @if (lastSuccessfulManureOfferPost$ | async; as post) {
    <div class="resume-container spacing--margin-left">
      <div class="offer-header-container spacing--margin-bottom">
        <div
          class="text--bold text--h3 text-color--primary spacing--margin-top spacing--margin-bottom spacing--margin-left"
        >
          {{ 'resume-page.offer.header' | translate }}
        </div>
        <div class="subheader-container spacing--margin-left spacing--margin-bottom text--body">
          {{ 'resume-page.sub-header' | translate }}
          <span class="sub-header-button">{{ 'resume-page.sub-header-button' | translate }}</span>
        </div>
      </div>
      <div class="spacing--margin-bottom">
        <div
          class="table-container spacing--margin-left spacing--padding-all spacing--margin-right"
        >
          <div class="table-responsive">
            <table>
              <tr>
                <th class="narrow text--small text--bold">
                  {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
                </th>
                <th class="wide text--small text--bold">
                  {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
                </th>
                <th class="wide-homogeneous text--label">
                  {{ 'dashboard.overview-table.table-headers.homogeneous' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate }}
                </th>
                <th class="price-per-ton narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.pricePerTon' | translate }}
                </th>
                <th class="narrow text--label">
                  {{ 'dashboard.overview-table.table-headers.price' | translate }}
                </th>
              </tr>
              <tr class="table-row">
                <td class="text--small text--bold">
                  {{ 'manureCategories.' + post.manureCategory | translate }}
                </td>
                <td class="text--small text--bold">
                  {{ 'manureTypes.' + post.manureType | translate }}
                </td>
                <td class="narrow text--small text--bold">{{ post.amountInTons }}</td>
                <td class="narrow text--small">{{ post.nKgPerTon | number }}</td>
                <td class="narrow text--small">
                  @if (post.nKgPerTon) {
                    {{ post.nKgPerTon * post.amountInTons | number }}
                  } @else {}
                </td>
                <td class="narrow text--small">{{ post.pKgPerTon | number }}</td>
                <td class="narrow text--small">
                  @if (post.pKgPerTon) {
                    {{ post.pKgPerTon * post.amountInTons | number }}
                  } @else {}
                </td>
                <td class="narrow text--small">{{ post.kKgPerTon | number }}</td>
                <td class="narrow text--small">
                  <div>
                    @switch (post.isHomogeneous) {
                      @case (true) {
                        <p>{{ 'homogeneity.homogeneous' | translate }}</p>
                      }
                      @case (false) {
                        <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
                      }
                      @case (null) {
                        <p>{{ 'homogeneity.empty' | translate }}</p>
                      }
                    }
                  </div>
                </td>
                <td class="narrow text--small text--bold">
                  {{
                    post.desiredDeliveryPeriodFrom
                      ? ('shorthand-months.' + post.desiredDeliveryPeriodFrom | translate)
                      : ('' | translate)
                  }}
                  {{ post.desiredDeliveryPeriodFrom && post.desiredDeliveryPeriodTo ? '-' : '' }}
                  {{
                    post.desiredDeliveryPeriodTo
                      ? ('shorthand-months.' + post.desiredDeliveryPeriodTo | translate)
                      : ('' | translate)
                  }}
                </td>
                <td class="narrow text--small text--bold">
                  {{ post.pricePerTon | currency: 'EUR' }}
                </td>
                <td class="narrow text--small">
                  {{ post.amountInTons * post.pricePerTon | currency: 'EUR' }}
                </td>
              </tr>
            </table>
          </div>
          <div class="list-responsive">
            <table class="table-no-borders">
              <tr class="spacing--margin-bottom">
                <td class="text--small text--bold">
                  {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
                </td>
                <td class="text--small text--bold">
                  {{ 'manureCategories.' + post.manureCategory | translate }}
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small text--bold">
                  {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
                </td>
                <td class="text--small text--bold">
                  {{ 'manureTypes.' + post.manureType | translate }}
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
                </td>
                <td class="text--small text--bold">{{ post.amountInTons }}</td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
                </td>
                <td class="text--small">{{ post.nKgPerTon }}</td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
                </td>
                <td class="text--small max-nitrogen-field">
                  @if (post.nKgPerTon) {
                    {{ post.nKgPerTon * post.amountInTons }}
                  } @else {}
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
                </td>
                <td class="text--small">{{ post.pKgPerTon }}</td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
                </td>
                <td class="text--small max-phosphate-field">
                  @if (post.pKgPerTon) {
                    {{ post.pKgPerTon * post.amountInTons }}
                  } @else {}
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td class="text--small">
                  {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
                </td>
                <td class="text--small">{{ post.kKgPerTon }}</td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td>
                  <span class="text--small">{{
                    'dashboard.overview-table.table-headers.kKgPerTon' | translate
                  }}</span>
                </td>
                <td>
                  <span class="text--small">{{ post.kKgPerTon }}</span>
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td>
                  <span class="text--small text--bold">{{
                    'dashboard.overview-table.table-headers.homogeneous' | translate
                  }}</span>
                </td>
                @if (post.isHomogeneous) {
                  <td>
                    <span class="text--small">{{ 'homogeneity.homogeneous' | translate }}</span>
                  </td>
                } @else {
                  <td>
                    <span class="text--small">{{ 'homogeneity.notHomogeneous' | translate }}</span>
                  </td>
                }
              </tr>
              <tr class="spacing--margin-bottom">
                <td>
                  <span class="text--small">{{
                    'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
                  }}</span>
                </td>
                <td>
                  <span class="text--small text--bold"
                    >{{
                      post.desiredDeliveryPeriodFrom
                        ? ('shorthand-months.' + post.desiredDeliveryPeriodFrom | translate)
                        : ('' | translate)
                    }}
                    {{ post.desiredDeliveryPeriodFrom && post.desiredDeliveryPeriodTo ? '-' : '' }}
                    {{
                      post.desiredDeliveryPeriodTo
                        ? ('shorthand-months.' + post.desiredDeliveryPeriodTo | translate)
                        : ('' | translate)
                    }}
                  </span>
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td>
                  <span class="text--small">{{
                    'dashboard.overview-table.table-headers.pricePerTon' | translate
                  }}</span>
                </td>
                <td>
                  <span class="text--small text--bold">{{
                    post.pricePerTon | currency: 'EUR'
                  }}</span>
                </td>
              </tr>
              <tr class="spacing--margin-bottom">
                <td>
                  <span class="text--small">{{
                    'dashboard.overview-table.table-headers.price' | translate
                  }}</span>
                </td>
                <td>
                  <span class="text--small total-price-field">{{
                    post.amountInTons * post.pricePerTon | currency: 'EUR'
                  }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div class="spacing--margin-top spacing--margin-bottom text--label information-container">
            *{{ 'resume-page.offer.transport-info' | translate }}
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-text-container spacing--margin-left text--normal spacing--margin-bottom">
          {{ 'resume-page.offer.button-header' | translate }}
        </div>
        <agr-primary-action
          [actionText]="'resume-page.offer.overview-redirect-button' | translate"
          class="primary-button spacing--margin-left place-offer-button-container spacing--margin-bottom"
          (click)="redirectToOfferOverview()"
        ></agr-primary-action>
        <div
          (click)="redirectToNewOffer()"
          class="new-offer-button spacing--margin-left spacing--margin-top text--center text--small"
        >
          {{ 'resume-page.offer.new-offer-button' | translate }}
        </div>
      </div>
    </div>
  }
</agr-page-toolbar>
